import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=dac6fd2e&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=dac6fd2e&scoped=true&lang=scss&"
import style1 from "./detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac6fd2e",
  null
  
)

export default component.exports